import React from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WhySection from './components/WhySection';
import PricingSection from './components/PricingSection';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <section id="about">
        <AboutSection />
      </section>
      <section id="features">
        <WhySection />
      </section>
      <section id="pricing">
        <PricingSection />
      </section>
      <Footer />
    </div>
  );
};

export default App;
